import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Sidebar } from 'primereact/sidebar';
import { useEffect, useState } from 'react';
import Tag from '../../../../components/Display/Tag';
import FormInput from '../../../../components/Form/FormInput';
import RichTextEditor from '../../../../components/Form/RichTextEditor';
import { CONSTANT } from '../../../../utils/constants';
import ImageForm from '../../common/image/ImageForm';
import { InputTextarea } from 'primereact/inputtextarea';

function HighlightManager({
  isOpen,
  highlight,
  onUpdate,
  loading,
  onCreate,
  onClose,
  duplicationMode
}) {
  const [title, setTitle] = useState('');
  const [type, setType] = useState('');
  const [resume, setResume] = useState('');
  const [description, setDescription] = useState('');

  const [isDraft, setIsDraft] = useState(false);
  const [image, setImage] = useState(undefined);

  useEffect(() => {
    if (highlight) {
      setTitle(highlight.title);
      setType(highlight.type);
      setImage(highlight.image);
      setIsDraft(highlight.is_draft);
      setDescription(highlight.description);
      setResume(highlight.resume);
    } else {
      setTitle('');
      setType('');
      setImage(undefined);
      setIsDraft(true);
      setDescription('');
      setResume('');
    }
  }, [highlight, onCreate, onUpdate]);

  const handleValidate = () => {
    const highlightPayload = {
      title,
      type,
      image: image?.id,
      is_draft: isDraft,
      resume,
      description
    };
    if (duplicationMode || !highlight) {
      onCreate(highlightPayload);
    } else {
      onUpdate(highlightPayload);
    }
  };

  const formIsValid = () => {
    return title.length > 3 && description.length > 3 && type;
  };

  const statusTemplate = (option) => <Tag tag={{ label: option.label, bgColor: option.bgColor }} />;

  const footerButtons = (
    <div className="manage-footer">
      <Button
        key={'validate'}
        label={`Valider la ${!highlight || duplicationMode ? 'création' : 'modification'}`}
        className="w-full"
        onClick={handleValidate}
        severity="success"
        disabled={!formIsValid()}
        loading={loading}
      />
    </div>
  );

  return (
    <Sidebar
      style={{ width: 700 }}
      visible={isOpen}
      position="right"
      onHide={onClose}
      header={
        <h3 className="text-slate-800 text-2xl font-medium">{`${!highlight || duplicationMode ? 'Ajouter' : 'Modifier'} un Temps fort / Alumni`}</h3>
      }>
      <div className="sidebar-content-container">
        <div className="form-wrapper">
          <FormInput key="type" label={'Type'} required isValid={type}>
            <Dropdown
              value={type}
              options={CONSTANT.quatrebis.highlightType}
              optionLabel="label"
              onChange={(e) => setType(e.value)}
              placeholder="Indiquez le type"
              className="grow"
            />
          </FormInput>
          <FormInput
            key="title"
            label={'Titre du temps fort / Alumni'}
            required
            isValid={title.length > 3}>
            <InputText
              id="title"
              value={title}
              maxLength={300}
              placeholder="Veuillez saisir le titre du temps fort / Alumni"
              onChange={(e) => setTitle(e.target.value)}
            />
          </FormInput>

          <FormInput key="place" label={'Statut du temps fort / Alumni'}>
            <Dropdown
              value={isDraft}
              options={CONSTANT.shared.draftTypes}
              optionLabel="label"
              onChange={(e) => setIsDraft(e.value)}
              className="grow"
              valueTemplate={statusTemplate}
              itemTemplate={statusTemplate}
            />
          </FormInput>

          <FormInput label={'Résumé'} required isValid={resume.length > 3}>
            <InputTextarea
              id="resume"
              rows={5}
              autoResize
              value={resume}
              placeholder="Veuillez saisir une description courte, présente dans le menu et haut de page"
              onChange={(e) => setResume(e.target.value)}
            />
          </FormInput>

          <FormInput
            key="description"
            label={'Description'}
            required
            isValid={description?.length > 3}>
            <RichTextEditor
              value={description}
              onChange={(value) => {
                setDescription(value);
              }}
              acceptHeaders
              acceptImage
            />
          </FormInput>
          <ImageForm
            image={image}
            setImage={setImage}
            deleteImage={() => setImage(undefined)}
            required={false}
          />
        </div>
        {footerButtons}
      </div>
    </Sidebar>
  );
}

export default HighlightManager;
